import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCartSummary } from 'src/hooks';
import { getUpdatedApplicationState } from 'src/library';
import { dispatchAppHookEvent } from '@bold-commerce/checkout-frontend-library';
// import {IBreadcrumbsProps} from 'src/types';
// import {getBreadcrumbs} from 'src/utils';

export function InsuranceProtection(props: any): React.ReactElement {

    const { totals, lineItems } = useCartSummary();
    const dispatch = useDispatch();

    const [onChecked, setOnChecked] = useState(true);
    const [price, setPrice] = useState(0);

    useEffect(() => {
        const totalWithoutInsurance = parseFloat((totals / 100).toFixed(2));
        let insurancePrice = 0;

        if(totalWithoutInsurance > 100){
            insurancePrice = parseFloat((totalWithoutInsurance * 0.03).toFixed(2));
        } else {
            insurancePrice = 0.97;
        }

        console.log('totals and insurance: ', totals, totalWithoutInsurance, insurancePrice)

        setPrice(insurancePrice);
    }, [totals])


    const handleToggleInsuranceProtection = async () => {
        const newIsChecked = !onChecked;
        setOnChecked(previousOnChecked => !previousOnChecked)

        const requestBody = {
            uuid: "79fa0d14-3714-4a8e-a350-5f9bcd4719f3",
            hook: "insurance_toggle",
            app_hook_data: {
                insurance_data: {
                    isChecked: newIsChecked
                }
            }
        }

        await dispatchAppHookEvent(requestBody)
        await dispatch(getUpdatedApplicationState);
        console.log('updated Line Item Quantity')
    }

    return (
        <div>
            <h2 className="field-section__heading" style={{ display: 'inline-block' }}>Package Insurance Protection</h2>
            <div className="checkout_page_checkbox" id="insurance-checkbox">
                <div className="checkout_page_image_div">
                    <div className="checkout_page_image">
                        <img src="https://cdn11.bigcommerce.com/s-e3gxtkmyd6/images/stencil/original/image-manager/checkout-cart2.png" width="80" alt="Shipping Cart" />
                    </div>
                    <div className="checkout_page_image_div_text">
                        <p className="image_div_text_first">Package Insurance Protection</p>
                        <p className="image_div_text_second">Against loss, theft, or damage in transit. <a href="#" target="_blank">Learn More</a></p>
                    </div>
                </div>
                <div className="checkout_page_switch_div">
                    <div className="shipping_price">
                        <p>${price.toFixed(2)}</p>
                    </div>
                    <div>
                        <label className="checkout_page_switch" id="slider-checkbox-wrapper" onClick={handleToggleInsuranceProtection}>
                            <div id="slider-checkbox" aria-checked={onChecked}></div>
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="bottom_text">
                <p>
                    *By opting out of shipping protection, we are not liable for lost, damaged, or stolen packages during transit.
                </p>
            </div>
        </div>
    );
}
